// extracted by mini-css-extract-plugin
export default {"Options":"LeavePageModal_Options__Q-6uL","RightSide":"LeavePageModal_RightSide__Fh0tx"};